import AddIcon from "@mui/icons-material/Add";
import { Box, Button } from "@mui/joy";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import NotesDialog from "../Dialogs/NotesDialog";
import { Util } from "../Helpers/Util";
import PortalTableLayout from "../components/PortalTableLayout";

interface NotesListingProps {
	buildingId: string;
}

interface Note {
	buildings_id: string;
	created_by: string;
	created_date: string;
	description: string;
	notes_id: string;
	title: string;
}

export default function NotesListing(props: NotesListingProps) {
	const [notes, setNotes] = React.useState([] as Array<Note>);
	const [dialog, setDialog] = React.useState(false);
	const [nId, setNId] = React.useState("");

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		setDialog(false);
		fetch("Building/GetNotes", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setNotes(x as Array<Note>));
	};
	return (
		<>
			{dialog && <NotesDialog buildingId={props.buildingId} notesId={nId} close={getData} />}
			<PortalTableLayout
				fillHeight={false}
				toolbar={
					<Box sx={{ p: 1, alignSelf: "flex-start" }}>
						<Button
							sx={{ minWidth: 120 }}
							startDecorator={<AddIcon />}
							onClick={() => {
								setNId("");
								setDialog(true);
							}}>
							Add Note
						</Button>
					</Box>
				}>
				<Table stickyHeader size="small">
					<TableHead>
						<TableRow>
							<TableCell>Title</TableCell>
							<TableCell>Description</TableCell>
							<TableCell>Created By</TableCell>
							<TableCell>Date Created</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{notes.map((x) => (
							<TableRow
								key={x.notes_id}
								hover
								sx={{ cursor: "pointer" }}
								onClick={() => {
									setNId(x.notes_id);
									setDialog(true);
								}}>
								<TableCell>{x.title}</TableCell>
								<TableCell>{x.description}</TableCell>
								<TableCell>{x.created_by}</TableCell>
								<TableCell>{Util.Formatter(x.created_date, "D")}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</PortalTableLayout>
		</>
	);
}
